import {useState, useEffect} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useRegistration} from '../../../contexts/RegistrationContext';

import styled from 'styled-components';
import config from '../../../config';
import {
  SubInner,
  TabHeader,
  SectionTitle,
  InputLabel,
  RequiredLabel,
  FormInput,
} from '../../atoms/CommonParts';
import {ScannedDevice, StepWrap} from '.';
import {useApp} from '../../../contexts/AppContext';
import {CountrySelect, AreaSelect} from '../../organisms/CountrySelect';
import {
  useCustomDialog,
  ButtonLayout,
} from '../../../contexts/CustomDialogContext';
import {
  NotLoginedHeaderArea,
} from '../../organisms/CommonParts';

const Page = styled.div``;

const InputExplanation = styled.div`
  text-align: right;
  margin-top: 10px;
  font-size 12px;
  font-weight: bold;
  line-height: 1;
`;

export default function RegistrationPageStep1() {
  const registration = useRegistration();
  const app = useApp();
  const venue = registration.state.venue;
  const [country, setCountry] = useState(venue.country);
  const [area, setArea] = useState(venue.area);
  const {customDialog} = useCustomDialog();
  const countries = app.state.countries || [];

  useEffect(() => {
    app.hideHeader();
  }, []);

  function handleSubmit(event) {
    event.preventDefault();

    let formData = new FormData(event.currentTarget);
    let name = (formData.get('name') || '').trim().substr(0, 256);
    let zipcode = (formData.get('zipcode') || '').trim().substr(0, 256);
    let address = (formData.get('address') || '').trim().substr(0, 256);
    let phone = (formData.get('phone') || '').trim().substr(0, 256);
    let website = formData.get('website').trim().substr(0, 256);

    let errors = [];
    if (!area) {
      errors.push('- Choose an area.');
    }
    if (!zipcode) {
      errors.push('- Zip Code is required.');
    }
    if (!name) {
      errors.push('- Venue Name is required.');
    }
    if (!address) {
      errors.push('- Address is required.');
    }
    if (!website) {
      errors.push('- Website is required.');
    }

    if (errors.length) {
      (async function() {
        await customDialog({
          buttons: ButtonLayout.None,
          description_element: (
              <ul>
                {errors.map((e, i) => {
                  return <li key={i}>{e}</li>;
                })}
              </ul>
          ),
        });
      })();
      return;
    }

    registration.dispatch({
      type: 'set_venue',
      venue: {
        country,
        area,
        name,
        zipcode,
        address,
        phone,
        website,
      },
    });
    registration.dispatch({
      type: 'step2',
    });
  }

  function onSelectCountry(_country) {
    if (_country) {
      setCountry(_country);
      let c = countries.find((_c) => _c.country == _country);
      if (c && c.areas.length == 1) {
        setArea(c.areas[0].area);
      } else {
        setArea('');
      }
    }
  }

  function onSelectArea(_area) {
    if (_area) {
      setArea(_area);
    }
  }

  return (
      <Page>
        <NotLoginedHeaderArea
            style={{
              'margin-bottom': 40,
            }}
        />
        <ScannedDevice/>
        <SectionTitle
            style={{
              marginBottom: 20,
            }}
        >
          Setup
        </SectionTitle>
        <TabHeader
            buttons={[
              {
                title: 'Venue',
              },
              {
                title: 'Device',
                disabled: true,
              },
            ]}
            selectedIndex={0}
        />
        <SubInner>
          <form onSubmit={handleSubmit}>
            <StepWrap
                subTitle={'Enter venue information'}>

              <RequiredLabel/>
              <InputLabel required={true}>Country</InputLabel>
              <CountrySelect country={country}
                             onSelectCountry={onSelectCountry}/>
              <InputLabel required={true}>Area</InputLabel>
              <AreaSelect
                  country={country}
                  area={area}
                  onSelectArea={onSelectArea}
              />
              <InputLabel required={true}>Venue name</InputLabel>
              <FormInput
                  type="text"
                  required
                  name="name"
                  defaultValue={venue.name}
              />
              <InputLabel required={true}>Zip code</InputLabel>
              <FormInput
                  type="text"
                  required
                  name="zipcode"
                  defaultValue={venue.zipcode}
              />
              <InputLabel required={true}>Address</InputLabel>
              <FormInput
                  type="text"
                  required
                  name="address"
                  defaultValue={venue.address}
              />
              <InputExplanation>Room/house no. and street
                name</InputExplanation>
              <InputLabel required={false}>Phone number</InputLabel>
              <FormInput type="text" name="phone" defaultValue={venue.phone}/>
              <InputExplanation>Including country code</InputExplanation>
              <InputLabel required={true}>Website</InputLabel>
              <FormInput
                  type="url"
                  required
                  name="website"
                  defaultValue={venue.website}
                  placeholder={'https://'}
              />
              <InputExplanation>URL must start with http:// or
                https://</InputExplanation>

              <button
                  type="submit"
                  className="dark-button center-fixed primary"
                  style={{
                    margin: '40px auto 0',
                  }}
              >
                <span>Next</span>
              </button>
            </StepWrap>
          </form>
        </SubInner>
      </Page>
  );
}
